module.exports = __webpack_public_path__ + "img/22.d4e24567.png";